import {utc} from '@netx/core/lib/netx-moment';

/**
 * @param expirationDate datetime in milliseconds
 */
export const assetExpirationToDateString = (expirationDate: number) => {
	return `${utc(expirationDate).local().format('YYYY-MM-DD')}`;
};

export default assetExpirationToDateString;
